<template>
  <div>
    <back-btn />
    <v-container fluid>
      <v-row justify="center">
        <v-col lg="8">
          <v-card class="pa-2" elevation="0">
            <v-card-text>
              <div class="pb-6">
                <h2 class="heading-3 text-center font-weight-light grey--text">
                  DOTS Reported Volunteers List
                </h2>
              </div>
              <v-row>
                <v-col class="col--padding" lg="3">
                  <label>Month</label>
                  <v-select
                    class="mr-1"
                    :items="export_months"
                    v-model="month"
                    item-text="text"
                    :error-messages="handleFieldErrors($v.month)"
                    item-value="value"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col class="col--padding" lg="3">
                  <label>Year</label>
                  <v-select
                    class="mr-1"
                    :items="years"
                    v-model="year"
                    item-text="text"
                    item-value="value"
                    :error-messages="handleFieldErrors($v.year)"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col class="col--padding" lg="6">
                  <label>Townships</label>
                  <v-select
                    class="mr-3"
                    v-model="townshipId"
                    placeholder="choose township..."
                    hide-details
                    outlined
                    dense
                    item-text="name"
                    item-value="id"
                    :items="townships"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="col--padding" lg="3">
                  <div>
                    <v-btn
                      class="ml-4"
                      height="40"
                      color="purple accent-4"
                      @click.prevent="getVolReportedList"
                      outlined
                      rounded
                      dark
                    >
                      <v-icon left>mdi-file-table-box</v-icon>
                      view report
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card elevation="0" :loading="loading">
            <v-row>
              <v-col>
                <div v-if="volDotsReportedData.length != 0">
                  <!-- export btn -->
                  <div style="width: 15%">
                    <export-volunteer
                      :volData="volDotsReportedData"
                      :month="month"
                      :year="year"
                      :townshipName="townshipName"
                      :dots="true"
                    />
                  </div>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">No</th>
                          <th class="text-left">Code</th>
                          <th class="text-left">Name</th>
                          <th class="text-left">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in volDotsReportedData" :key="i">
                          <td>{{ ++i }}</td>
                          <td>{{ item.code }}</td>
                          <td>{{ item.name }}</td>
                          <td>
                            <v-icon
                              @click="viewDetail(item.id)"
                              class="teal--text"
                            >
                              mdi-view-comfy
                            </v-icon>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "../../../mixins/ValidationMixin";
import { mapState } from "vuex";
import BackBtn from "@/components/navigation/BackBtn.vue";
import ExportVolunteer from "@/components/report/volunteer/ExportVolunteer.vue";

export default {
  components: { BackBtn, ExportVolunteer },
  mixins: [ValidationMixin],
  data: () => ({
    month: null,
    year: null,
    townshipId: null,
    townshipName: "",
  }),
  validations: {
    month: {
      required,
    },
    year: {
      required,
    },
  },
  methods: {
    viewDetail(volunteer_id) {
      this.$router.push({
        name: "volunteer-detail",
        query: {
          month: this.month,
          year: this.year,
          id: volunteer_id,
          is_dots_report: true,
        },
      });
    },
    getVolReportedList() {
      this.$v.$touch();
      this.townshipName = this.townships.find(
        (twn) => twn.id === this.townshipId
      ).name;
      if (!this.$v.$invalid) {
        this.$store.dispatch("Report/getVolunteerDOTSReported", {
          month: this.month,
          year: this.year,
          township_id: this.townshipId,
        });
      }
    },
  },
  computed: {
    ...mapState("InitialData", ["export_months", "years"]),
    ...mapState("Report", ["volDotsReportedData"]),
    ...mapState("Loading", ["loading"]),
    ...mapState("Township", ["townships"]),
  },
  created() {
    this.$store.dispatch("Township/getTownships");
  },
};
</script>
